import React, { useRef, useState, useEffect } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, Row, Col } from "react-bootstrap";
import bannerImage from "../../Images/Banner/honarable-banner.webp";
import chancellor from "../../Images/Hon'ble Persons/Dr. Vinay M. Agrawal-6.webp";
import visitor from "../../Images/Hon'ble Persons/Hon’ble Shri Raman Deka.webp";
import patron from "../../Images/Hon'ble Persons/Shri Mahesh Agrawal.webp";
import viceChancellor from "../../Images/Hon'ble Persons/Prof. (Dr.) Anand Mahalwar.webp";
import officialRegistar from "../../Images/Hon'ble Persons/Dr. B.P. Bhol.webp";
import quoteIcon from "../../Images/about/quotemark.webp";

const LeadershipManagement = () => {
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const messages = [
    {
      id: 1,
      name: "Hon’ble Shri Raman Deka",
      designation: "Hon'ble Visitor",
      image: visitor,
      readMore: "/honorable-visitor",
      message:
        "Hon’ble Shri Raman Deka Ji serving as the Governor of Chhattisgarh, bringing with him a wealth of experience and dedication to public service. As a prominent political leader, Shri Raman Deka Ji has a distinguished career, marked by his commitment to the development and welfare of the people. His tenure as Governor is characterized by initiatives aimed at improving governance, enhancing infrastructure, and fostering economic growth in the state.",
      message1:
        "Shri Raman Deka Ji leadership is pivotal in addressing key issues such as education, healthcare, and rural development, ensuring that the benefits of progress reach every segment of society. His collaborative approach with various stakeholders, including government officials, industry leaders, and civil society, underscores his vision of a prosperous and inclusive Chhattisgarh.",
    },
    {
      id: 2,
      name: "Shri Mahesh Agrawal",
      designation: "Hon'ble Patron",
      image: patron,
      readMore: "/honorable-patron",
      message:
        "ISBM University was established in the year 2016 with an objective to cater the multifaceted educational needs of the millions. Its philosophy includes offering multiple courses and programmes for the students, preparing them to become successful in life and eventually to become responsible citizens of the country. We encourage them to develop their personality, by metamorphosing and nurturing them to become employable as well as venture into entrepreneurship. In a nutshell, we take all our efforts for academic growth & skill development of the students.",
      //   message1:
      //     "The challenges are accepted in collaboration with the stakeholder's viz. other Universities, research institutions, members of the faculty & society at large. The academic programmes are need-based catering to the needs of mankind. Excellence & relevance is a key parameter. It is to be set by the academic community & drive to achieve it. It is equally important we keep close to our communities both in the interest of our country and our neighborhood. It will help to ensure the on-going relevant academic programmes. I welcome all and congratulate the students, parents for choosing our University. I am sure that all stakeholders will be immensely benefited by an excellent academic pursuit.",
    },
    {
      id: 3,
      name: "Dr. Vinay M. Agrawal",
      designation: "Hon'ble Chancellor",
      image: chancellor,
      readMore: "/honorable-chancellor",
      message:
        "Education is an intervention in the modern society where, harmonious development can be achieved by enlightenment of an individual's heart, mind and soul. I am of the opinion that education can transform the attitude, thought process and lifestyle of the people leading to the development of the society Education makes people flexible in thinking rationally and making appropriate decisions. I have always worked towards empowering the mass. Education serves as the tool & technique of empowerment with skilled and socially relevant citizens.",
      //   message1:
      //     "ISBM University is proud of its state of the art infrastructure, serene campus with aesthetically built facilities. Student's friendly policies create a satisfying academic ambience in the campus. I extend my best wishes to all the aspirants in the campus and assure them that under the mentorship of experienced faculties of ISBM University they will be able to extract competitive advantage towards creating a harmonious, peaceful and rewarding future. Participation in a wide range of academics and other activities will provide them an opportunity to acquire leadership, skills, professional and personal traits.",
    },
    {
      id: 4,
      name: "Prof. (Dr.) Anand Mahalwar",
      designation: "Hon'ble Vice Chancellor",
      image: viceChancellor,
      readMore: "/honorable-vice-chancellor",
      message:
        "The University is a new-age University committed to provide innovative learning programmes to meet the current requirements of the society & industry. The programmes offered are research driven, skill based and knowledge intensive. The University is envisioned to be a centre of academic innovation and research where students and faculty will collaborate together to learn, research, create, innovate, inspire and incubate.",
      message1:
        "The University endeavors to offer services across the student-life cycle, supporting students not only with teaching and learning, but also with career development, skill enhancement, employment opportunities, business incubation, fund raising, and mentoring.",
    },
    {
      id: 5,
      name: "Dr. B.P. Bhol",
      designation: "Hon'ble Registrar",
      image: officialRegistar,
      readMore: "/official-registar",
      message:
        "On behalf of the Administration, faculty, and staff of ISBM University. I am pleased to extend a warm welcome to all of you. Education is a powerful tool that can break down the barriers to development, and higher education equips individuals with the ability to make better choices, gain access to economic stability, and achieve financial security. Our university is dedicated to providing quality education through the use of the latest technology and high academic standards. We have an excellent team of highly qualified, committed, and friendly staff members who are here to support our students and provide them with the best education possible. Our faculty members are also committed to advising and working with students to help them achieve their academic and professional goals. At ISBM University, we are committed to providing our students with improved career opportunities and greater socio-cultural awareness through our comprehensive curricular, co-curricular, and extra-curricular activities.",
      //   message1:
      //     "Our ultimate aim is to support our students and professionals in achieving success in their personal and professional lives, this results in increased career prospects and earning potential. Further to enhance our student's career we offer internships that provide practical opportunities for skill acquisition and career development.",
    },
  ];
  return (
    <>
      <title>Leadership & Management at ISBM University – Skills for Success</title>
      <meta
        name="description"
        content="Grow leadership & management abilities at ISBM University: training, governance, strategy, & hands-on practice for career success."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Leadership & Management</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Leadership & Management
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-center text-blue">
            Leadership & Management at ISBM University
          </h2>
          <div className="vc-paragraphs mx-auto">
            <p>
              At the heart of ISBM University lies a visionary leadership team
              committed to academic growth, excellence, and integrity. The
              Hon'ble Visitor and Hon'ble Patron provide strategic oversight and
              inspiration, guiding the institution to align with national
              education standards and global academic expectations. Their wisdom
              and commitment ensure that the university upholds the values of
              inclusivity, innovation, and student empowerment at every step.
            </p>
            <p>
              Our Hon'ble Chancellor plays a key role in shaping the long-term
              direction of the university. With a focus on building a robust
              academic ecosystem, the Chancellor oversees policy-level decisions
              and fosters a culture of research, ethics, and impactful
              education. Supporting this vision is our Hon'ble Vice-Chancellor,
              who ensures the smooth execution of academic strategies,
              institutional governance, and student-centric initiatives across
              all departments.
            </p>
            <p className="m-0">
              The Registrar, as the administrative head, manages academic
              records, regulatory compliance, and student services. Together,
              the leadership and management team work seamlessly to provide a
              transparent, responsive, and future-ready learning environment.
              Their combined efforts empower ISBM University to continuously
              innovate and evolve as a center of excellence in higher education.
            </p>
          </div>
        </div>
      </section>

      {/* Messages Section */}
      <section className="dignitaries-messages-section ptb-50 bg-light">
        <div classname="container-xxl">
          <Row className="g-4 justify-content-center m-0">
            {messages.map((dignitary) => (
              <Col lg={10} key={dignitary.id}>
                <Card className="border-0 shadow-lg dignitary-card">
                  <Row className="g-0">
                    <Col md={3} className="dignitary-image-col">
                      <div className="dignitary-image-container position-relative h-100">
                        <img
                          src={dignitary.image}
                          alt={dignitary.name}
                          className="img-fluid w-100 h-100"
                          style={{ objectFit: "contain" }}
                        />
                        <div className="dignitary-overlay d-flex flex-column justify-content-end">
                          <div className="overlay-content">
                            <h3 className="text-white mb-2">
                              {dignitary.name}
                            </h3>
                            <p className="text-light mb-0">
                              {dignitary.designation}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={8}>
                      <Card.Body className="p-4 p-lg-5">
                        <div className="dignitary-quote-mark mb-3">
                          <img src={quoteIcon} alt="Quote" width="40" />
                        </div>
                        <Card.Text>{dignitary.message}</Card.Text>
                        <Card.Text>{dignitary.message1}</Card.Text>
                        <div className="dignitary-signature mt-4 pt-3 border-top">
                          <p className="text-muted mb-1">With warm regards,</p>
                          <h5 className="text-blue mb-0">{dignitary.name}</h5>
                          <p className="text-muted small">
                            {dignitary.designation}
                          </p>
                        </div>
                        <a
                          href={dignitary.readMore}
                          className="accreditation-button"
                        >
                          Read More
                          <span className="download-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                            </svg>
                          </span>
                        </a>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default LeadershipManagement;
